import React, { useState } from 'react';
import LocalModal from 'components/base/local-modal';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import FundWalletModal from './fund-wallet-modal';
import CurrencyInput from 'components/base/currency-input';
import { formatCurrency, handleApiError } from 'utils/functions';
import InsufficientTag from 'components/base/insufficient-tag';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  userId?: string;
  eventId?: string;
};

const TopUpEventWalletModal = ({ isOpen, onClose, userId, eventId }: Props) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const { activeCompany, refetchMonthlyStat, companyWalletDetails } = useDashboardContext();
  const balance = companyWalletDetails?.available_balance as string;
  const companyId = activeCompany.id;

  const toggleFundWallet = () => {
    setShowFundWalletModal(!showFundWalletModal);
  };

  const topUpEvent = async () => {
    const data = {
      user_id: userId,
      amount,
      company_id: companyId,
      event_id: eventId
    };
    try {
      setLoading(true);
      const res = await apiService.post('company/event/transfer', { data });
      if (res) {
        toast(<ToastMessage type='success' message='Event topup successfully' />);
        setAmount('');
        onClose();
        refetchMonthlyStat();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <LocalModal
      title='Top up event wallet'
      isOpen={isOpen}
      onRequestClose={() => {
        setAmount('');
        onClose();
      }}
      footer={
        <div className='flex justify-end'>
          <Button
            loading={loading}
            variant='block'
            color='primary'
            onClick={topUpEvent}
            disabled={+amount > Number(balance) || +amount <= 0}
            className='w-auto h-[41px] self-end text-sm'>
            Confirm
          </Button>
        </div>
      }>
      <div className='mb-6'>
        <CurrencyInput
          label='Top up amount?'
          placeholder='500,000'
          value={amount}
          onChange={(v) => setAmount(v)}
        />
      </div>

      <div className='flex justify-between border-2 border-[#E60A2B] rounded-md p-3 items-center cursor-pointer'>
        <div>
          <p className='text-[#2E3031] font-medium'>Food Court Wallet</p>
          <p className='text-[#6F7376] text-sm'>Balance: {formatCurrency(balance)}</p>
        </div>
        <div>
          <InsufficientTag insufficient={+amount > Number(balance)} />
        </div>
      </div>
      {+amount > Number(balance) && (
        <div
          onClick={toggleFundWallet}
          className='text-[#0080E5] text-sm mt-2 cursor-pointer font-medium'>
          + Fund wallet
        </div>
      )}

      <FundWalletModal isOpen={showFundWalletModal} onClose={toggleFundWallet} />
    </LocalModal>
  );
};

export default TopUpEventWalletModal;
